/*
 * Duallys Only Vehicle SEO URL Helper
 *
 * Builds display-friendly vehicle fitment URLs from the Year / Make / Model
 * selector while preserving Shopify's native /search route for the actual
 * product results query.
 */
(function () {
  'use strict';

  var supportedBolts = ['10x225', '8x165.1', '8x170', '8x200', '8x210', '8x6.5'];
  var knownVehicles = [
    { key: 'gm-chevy-3500hd-dually', make: 'Chevy', model: '3500HD Dually' },
    { key: 'gmc-3500hd-dually', make: 'GMC', model: '3500HD Dually' },
    { key: 'ram-3500-dually', make: 'Ram', model: '3500 Dually' },
    { key: 'ford-f-350-dually', make: 'Ford', model: 'F-350 Dually' },
    { key: 'ford-f-450-dually', make: 'Ford', model: 'F-450 Dually' },
    { key: 'gm-chevy-3500-dually', make: 'Chevy', model: '3500 Dually' },
    { key: 'gmc-3500-dually', make: 'GMC', model: '3500 Dually' },

    // Keep pre-v544 combined GM paths redirectable, but mark them as ambiguous
    // so they are never saved as a specific vehicle for order/TPMS purposes.
    { key: 'gm-chevy-gmc-3500hd-dually', make: '', model: '3500HD Dually', legacyAmbiguous: true },
    { key: 'gm-3500-dually', make: '', model: '3500 Dually', legacyAmbiguous: true }
  ];

  function slugify(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, ' ')
      .replace(/\+/g, ' plus ')
      .replace(/\./g, '-')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .replace(/-+/g, '-');
  }

  function getBoltSlug(bolt) {
    return slugify(bolt);
  }

  function buildSlug(year, make, model, bolt) {
    var yearPart = String(year || '').trim();
    // Preserve the existing GM Chevy SEO URL format while the customer-facing
    // make label is simply Chevy.
    var slugMake = make === 'Chevy' ? 'GM Chevy' : make;
    var vehiclePart = slugify([slugMake, model].filter(Boolean).join(' '));
    var boltPart = getBoltSlug(bolt);
    return [yearPart, vehiclePart, boltPart].filter(Boolean).join('-');
  }

  function buildPrettyPath(year, make, model, bolt) {
    var slug = buildSlug(year, make, model, bolt);
    return slug ? '/' + slug : '';
  }

  function getBoltFromSlug(slug) {
    var normalizedSlug = slugify(slug);
    for (var i = 0; i < supportedBolts.length; i += 1) {
      var bolt = supportedBolts[i];
      var boltSlug = getBoltSlug(bolt);
      if (normalizedSlug === boltSlug || normalizedSlug.slice(-1 * (boltSlug.length + 1)) === '-' + boltSlug) {
        return bolt;
      }
    }
    return '';
  }

  function parseVehicleSlug(slug) {
    var normalizedSlug = slugify(slug);
    var bolt = getBoltFromSlug(normalizedSlug);
    if (!bolt) return null;

    var boltSlug = getBoltSlug(bolt);
    var withoutBolt = normalizedSlug.replace(new RegExp('-?' + boltSlug + '$'), '');
    var yearMatch = withoutBolt.match(/^(\d{4})-(.+)$/);
    if (!yearMatch) return null;

    var year = parseInt(yearMatch[1], 10);
    var vehicleKey = yearMatch[2];
    var matchedVehicle = null;

    knownVehicles.some(function (vehicle) {
      if (vehicleKey === vehicle.key) {
        matchedVehicle = vehicle;
        return true;
      }
      return false;
    });

    if (!matchedVehicle) return null;

    return {
      year: year,
      make: matchedVehicle.make,
      model: matchedVehicle.model,
      bolt: bolt,
      seoSlug: normalizedSlug,
      seoPath: '/' + normalizedSlug,
      legacyAmbiguous: matchedVehicle.legacyAmbiguous === true
    };
  }

  function getCurrentSlugFromPath() {
    return String(window.location.pathname || '').replace(/^\/+|\/+$/g, '');
  }

  function redirectPrettyVehiclePathToSearch() {
    if (!window.location || window.location.pathname === '/search') return;

    var slug = getCurrentSlugFromPath();
    if (!slug) return;

    var parsed = parseVehicleSlug(slug);
    if (!parsed || !parsed.bolt) return;

    try {
      if (parsed.legacyAmbiguous) {
        localStorage.removeItem('selectedVehicle');
      } else {
        localStorage.setItem('selectedVehicle', JSON.stringify(parsed));
      }
    } catch (err) {
      // localStorage can fail in restricted browsing modes; the redirect still works.
    }

    var currentUrl = new URL(window.location.href);
    var targetUrl = new URL('/search', window.location.origin);
    targetUrl.searchParams.set('q', parsed.bolt);
    targetUrl.searchParams.set('options[prefix]', 'none');
    targetUrl.searchParams.set('ymm', parsed.seoSlug);

    currentUrl.searchParams.forEach(function (value, key) {
      if (key === 'q' || key === 'options[prefix]' || key === 'ymm') return;
      targetUrl.searchParams.append(key, value);
    });

    window.location.replace(targetUrl.pathname + targetUrl.search);
  }

  function clearLegacyAmbiguousSelection() {
    try {
      var stored = JSON.parse(localStorage.getItem('selectedVehicle') || 'null');
      if (!stored) return;

      if (stored.make === 'GM Chevy') {
        stored.make = 'Chevy';
        localStorage.setItem('selectedVehicle', JSON.stringify(stored));
        return;
      }

      if (stored.make === 'GM Chevy & GMC' || stored.make === 'GM') {
        localStorage.removeItem('selectedVehicle');
      }
    } catch (err) {
      // Ignore malformed or unavailable localStorage and continue normally.
    }
  }

  clearLegacyAmbiguousSelection();

  window.duallyVehicleSeo = {
    slugify: slugify,
    buildSlug: buildSlug,
    buildPrettyPath: buildPrettyPath,
    getBoltFromSlug: getBoltFromSlug,
    parseVehicleSlug: parseVehicleSlug,
    redirectPrettyVehiclePathToSearch: redirectPrettyVehiclePathToSearch
  };

  redirectPrettyVehiclePathToSearch();
})();
